import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="market-footer">
      <div>
        <strong>Marketplace</strong>
        <span>Simple peer-to-peer buying and selling.</span>
      </div>
      <nav>
        <Link to="/">Shop</Link>
        <Link to="/list-product">Sell</Link>
        <a href="https://paolofiol.github.io/survey/index.html" target="_blank" rel="noopener noreferrer">
          Contact
        </a>
      </nav>
    </footer>
  );
}

export default Footer;
